export default __webpack_public_path__ + "static/media/uniden.2bc7a6e2.webp";